import { Button } from '@/components/ui';
import { useState } from 'react';
import { makeRequest } from '../../../services/makeRequest';

import statusElite from '../../../assets/img/status/elite-mob.svg';
import useLadyService from '@/services/LadyService';
import { Link } from 'react-router-dom';
import showToast from '../../toast/Toast';
import Popup from '../Popup';
import { format, fromUnixTime } from 'date-fns';

const RemoveEliteAdPopup = (props) => {
	const { setOpen, slug: slugProfile, name, id, setElite, elite_to } = props;
	const { t, lang } = useLadyService();

	const onClose = () => {
		setOpen(false);
	};

	const [isLoading, setIsLoading] = useState(false);

	const onSubmit = () => {
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const route = `user/elite/remove`;

				const method = 'DELETE';
				const payload = {
					profiles: [id],
				};

				await makeRequest({ route, method, payload });
				setElite(false);
				setIsLoading(false);
				onClose();
				showToast({
					message: t('success'),
					variant: 'success',
				});
			} catch (error) {
				showToast({
					message: t('oops'),
					variant: 'error',
				});
			}
		};

		fetchData();
	};

	const liOptions = [
		<li>{t('highad')}</li>,
		<li>
			<Link
				to={`/${lang}/czechia/elitelady`}
				target="_blank"
			>
				{t('placein')}
			</Link>
		</li>,
	];

	return (
		<Popup
			isLoading={isLoading}
			{...props}
		>
			<h2>{t('deactive')} Elite?</h2>

			<picture className="text-center mb-16">
				<source
					srcSet={statusElite}
					media="(min-width: 767.98px)"
				/>
				<img
					src={statusElite}
					alt={t('elite')}
				/>
			</picture>

			<span>
				{t('stauselite')}: <ul>{liOptions.map((i) => i)}</ul>
			</span>

			<span className="p1 color-main text-center">
				{t('eliteallow')}
				<p className="p1 color-green text-center mt-4">
					+50% {t('toviews')} {t('and')} +20% {t('toorders')}
				</p>
			</span>

			<div className={`attention-box important color-main`}>
				<span className={'attention-box__word'}>
					{t('important')}!{' '}
				</span>
				{t('eliteforad')}{' '}
				<Link
					target="_blank"
					to={`/profile/${slugProfile}`}
					className={'green'}
				>
					{name}
				</Link>{' '}
				{t('paiduntil')} {format(fromUnixTime(elite_to), 'dd.MM.yyyy')}{' '}
				{t('ifdeactivate')}.
			</div>

			<div className="fd-row gap-16 mt-16">
				<Button
					clazz={'button--secondary justify-center w-100'}
					onClick={onSubmit}
				>
					{t('deactive')}
				</Button>

				<Button
					clazz={'button--green justify-center w-100'}
					onClick={() => setOpen(false)}
				>
					{t('keep')} ELITE
				</Button>
			</div>
		</Popup>
	);
};

export default RemoveEliteAdPopup;
